import { render, staticRenderFns } from "./ViewLogisticProvince.vue?vue&type=template&id=569f92ff&scoped=true"
import script from "./ViewLogisticProvince.vue?vue&type=script&lang=ts"
export * from "./ViewLogisticProvince.vue?vue&type=script&lang=ts"
import style0 from "./ViewLogisticProvince.vue?vue&type=style&index=0&id=569f92ff&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "569f92ff",
  null
  
)

export default component.exports